function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_159",
  "data-name": "Path 159",
  d: "M0,214.663c.016,1.491.024,2.311.04,3.8A154.474,154.474,0,0,0,218.465.04l-3.8-.04Z",
  transform: "translate(0 0)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_160",
  "data-name": "Path 160",
  d: "M216.562,297.92A154.475,154.475,0,0,1,5.52,304.855L0,310.376c.016,1.491.024,2.311.04,3.8a154.472,154.472,0,0,0,261.6-118.309A153.913,153.913,0,0,1,216.562,297.92Z",
  transform: "translate(0 -95.713)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_161",
  "data-name": "Path 161",
  d: "M31.264,213.954l0,0a129.181,129.181,0,1,0,182.69-182.69l0,0Z",
  transform: "translate(-15.277 -15.277)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_162",
  "data-name": "Path 162",
  d: "M213.955,280.037a129.191,129.191,0,0,1-175.235,6.9l-7.457,7.457,0,0a129.175,129.175,0,0,0,220.32-98.523,128.689,128.689,0,0,1-37.63,84.168Z",
  transform: "translate(-15.277 -95.713)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "Group_31",
  "data-name": "Group 31",
  transform: "translate(66.834 66.848)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_163",
  "data-name": "Path 163",
  d: "M291.831,299.415a7.6,7.6,0,0,0,5.371-12.966h0c-1.08-1.08-9.24-7.235-13.609-2.867-1.312,1.312-2.455,3.836-.456,8.406a18.746,18.746,0,0,0,3.324,5.2A7.545,7.545,0,0,0,291.831,299.415Z",
  transform: "translate(-204.662 -204.666)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_164",
  "data-name": "Path 164",
  d: "M218.272,321.4c-6.113.9-6.037,11.121-5.815,12.634a7.594,7.594,0,0,0,14.645,1.506c1.183-3.212-.2-6.682-1.81-9.491-2.476-4.332-5.183-4.916-7.02-4.649Z",
  transform: "translate(-170.618 -223.876)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_165",
  "data-name": "Path 165",
  d: "M131.187,335.562a7.545,7.545,0,0,0,.206,5.809,7.593,7.593,0,0,0,14.026-.5,18.759,18.759,0,0,0,.863-6.113c-.078-4.989-2.167-6.81-3.905-7.458C136.587,325.14,131.721,334.13,131.187,335.562Z",
  transform: "translate(-130.703 -226.624)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_166",
  "data-name": "Path 166",
  d: "M321.4,218.27c-.9,6.114,8.908,8.99,10.419,9.212a7.6,7.6,0,1,0,2.216-15.029C332.518,212.233,322.3,212.157,321.4,218.27Z",
  transform: "translate(-223.859 -170.631)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_167",
  "data-name": "Path 167",
  d: "M334.77,146.294a17.014,17.014,0,0,0,6.113-.863,7.6,7.6,0,0,0-5.311-14.232,18.764,18.764,0,0,0-5.185,3.354c-3.718,3.328-3.725,6.1-3.076,7.837s2.469,3.826,7.458,3.9Z",
  transform: "translate(-226.619 -130.731)",
  fill: "rgba(147,147,147,0.69)"
}));

function SvgWatermelon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "watermelon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 261.806,
    height: 261.806,
    viewBox: "0 0 261.806 261.806",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatermelon);
export default __webpack_public_path__ + "static/media/watermelon.69728b16.svg";
export { ForwardRef as ReactComponent };